import { Component, Input } from "@angular/core";

@Component({
    selector: "web-no-data",
    templateUrl: "./no-data.component.html",
    styleUrls: ["./no-data.component.scss"],
})
export class NoDataComponent {
    @Input() title: string = "No Data Found";
    @Input() description: string = "";
    @Input() icon: string = "assets/svg/icons/no-data-gbs.svg";
    @Input() height: string = "150px";
}
